module.exports = __webpack_public_path__ + "img/car_status_Idle.895c8857.svg";